var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-checkbox.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * A customizable checkbox component that follows accessibility best practices.
 *
 * This component provides a checkbox with the following features:
 * - Three states: checked, unchecked, and indeterminate
 * - Keyboard navigation support
 * - Error state handling
 * - Accessibility features (ARIA attributes, screen reader support)
 * - Custom styling with focus indicators
 *
 * @tag sds-checkbox
 *
 * @fires sds.checkbox.changed - Fired when the checkbox state changes.
 *   Event is of `CustomEvent` type with details of `{checked: boolean, indeterminate: boolean}` type
 * @fires change - Native change event, fired when the checkbox state changes.
 *   Event is of `CustomEvent` type with details of `{checked: boolean, indeterminate: boolean}` type
 * @fires focus - Native focus event, fired when the checkbox receives focus
 * @fires blur - Native blur event, fired when the checkbox loses focus
 * @fires click - Native click event, fired when the checkbox is clicked
 */
let SdsCheckbox = (() => {
    var _SdsCheckbox_label_accessor_storage, _SdsCheckbox_description_accessor_storage, _SdsCheckbox_checked_accessor_storage, _SdsCheckbox_readonly_accessor_storage, _SdsCheckbox_indeterminate_accessor_storage, _SdsCheckbox_disabled_accessor_storage, _SdsCheckbox_invalid_accessor_storage, _SdsCheckbox_errorMessage_accessor_storage, _SdsCheckbox_value_accessor_storage, _SdsCheckbox_name_accessor_storage, _SdsCheckbox__checkbox_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-checkbox')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _label_decorators;
    let _label_initializers = [];
    let _label_extraInitializers = [];
    let _description_decorators;
    let _description_initializers = [];
    let _description_extraInitializers = [];
    let _checked_decorators;
    let _checked_initializers = [];
    let _checked_extraInitializers = [];
    let _readonly_decorators;
    let _readonly_initializers = [];
    let _readonly_extraInitializers = [];
    let _indeterminate_decorators;
    let _indeterminate_initializers = [];
    let _indeterminate_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let __checkbox_decorators;
    let __checkbox_initializers = [];
    let __checkbox_extraInitializers = [];
    var SdsCheckbox = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsCheckbox_label_accessor_storage.set(this, __runInitializers(this, _label_initializers, ''));
            _SdsCheckbox_description_accessor_storage.set(this, (__runInitializers(this, _label_extraInitializers), __runInitializers(this, _description_initializers, '')));
            _SdsCheckbox_checked_accessor_storage.set(this, (__runInitializers(this, _description_extraInitializers), __runInitializers(this, _checked_initializers, false)));
            _SdsCheckbox_readonly_accessor_storage.set(this, (__runInitializers(this, _checked_extraInitializers), __runInitializers(this, _readonly_initializers, false)));
            _SdsCheckbox_indeterminate_accessor_storage.set(this, (__runInitializers(this, _readonly_extraInitializers), __runInitializers(this, _indeterminate_initializers, false)));
            _SdsCheckbox_disabled_accessor_storage.set(this, (__runInitializers(this, _indeterminate_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsCheckbox_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsCheckbox_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsCheckbox_value_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _value_initializers, void 0)));
            _SdsCheckbox_name_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _name_initializers, void 0)));
            _SdsCheckbox__checkbox_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), __runInitializers(this, __checkbox_initializers, void 0)));
            /** Unique ID for the checkbox input */
            this._unique = (__runInitializers(this, __checkbox_extraInitializers), Math.random().toString(36).slice(2));
            /** Whether the checkbox is currently focused */
            this._isFocused = false;
            /** Whether the checkbox was clicked (vs. focused via keyboard) */
            this._isClicked = false;
        }
        /**
         * Label text displayed next to the checkbox
         * @attr
         */
        get label() { return __classPrivateFieldGet(this, _SdsCheckbox_label_accessor_storage, "f"); }
        set label(value) { __classPrivateFieldSet(this, _SdsCheckbox_label_accessor_storage, value, "f"); }
        /**
         * Additional descriptive text displayed below the label
         * @attr
         */
        get description() { return __classPrivateFieldGet(this, _SdsCheckbox_description_accessor_storage, "f"); }
        set description(value) { __classPrivateFieldSet(this, _SdsCheckbox_description_accessor_storage, value, "f"); }
        /**
         * Whether the checkbox is checked
         * @attr
         */
        get checked() { return __classPrivateFieldGet(this, _SdsCheckbox_checked_accessor_storage, "f"); }
        set checked(value) { __classPrivateFieldSet(this, _SdsCheckbox_checked_accessor_storage, value, "f"); }
        /**
         * Whether the checkbox is in read-only mode (non-interactive)
         * @attr
         */
        get readonly() { return __classPrivateFieldGet(this, _SdsCheckbox_readonly_accessor_storage, "f"); }
        set readonly(value) { __classPrivateFieldSet(this, _SdsCheckbox_readonly_accessor_storage, value, "f"); }
        /**
         * Whether the checkbox is in an indeterminate state (neither checked nor unchecked)
         * This is commonly used for "select all" checkboxes when some but not all items are selected
         * @attr
         */
        get indeterminate() { return __classPrivateFieldGet(this, _SdsCheckbox_indeterminate_accessor_storage, "f"); }
        set indeterminate(value) { __classPrivateFieldSet(this, _SdsCheckbox_indeterminate_accessor_storage, value, "f"); }
        /**
         * Whether the checkbox is disabled and cannot be interacted with
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsCheckbox_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsCheckbox_disabled_accessor_storage, value, "f"); }
        /**
         * Whether the checkbox is in an invalid state (e.g., required but not checked)
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsCheckbox_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsCheckbox_invalid_accessor_storage, value, "f"); }
        /**
         * Error message to display when the checkbox is invalid
         * @attr error-message
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsCheckbox_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsCheckbox_errorMessage_accessor_storage, value, "f"); }
        /**
         * The value associated with this checkbox.
         * @attr
         */
        get value() { return __classPrivateFieldGet(this, _SdsCheckbox_value_accessor_storage, "f"); }
        set value(value) { __classPrivateFieldSet(this, _SdsCheckbox_value_accessor_storage, value, "f"); }
        /**
         * The name of the checkbox for form submission.
         * @attr
         */
        get name() { return __classPrivateFieldGet(this, _SdsCheckbox_name_accessor_storage, "f"); }
        set name(value) { __classPrivateFieldSet(this, _SdsCheckbox_name_accessor_storage, value, "f"); }
        /** Reference to the native checkbox input element */
        get _checkbox() { return __classPrivateFieldGet(this, _SdsCheckbox__checkbox_accessor_storage, "f"); }
        set _checkbox(value) { __classPrivateFieldSet(this, _SdsCheckbox__checkbox_accessor_storage, value, "f"); }
        /**
         * Programmatically focuses the checkbox
         * This method can be called from outside the component to set focus
         */
        focus() {
            this._checkbox.focus();
            this._isFocused = true;
            this.requestUpdate();
        }
        /**
         * Programmatically clicks the checkbox
         * This method can be called from outside the component to toggle the checkbox
         */
        click() {
            this._checkbox.click();
        }
        /**
         * Handles the focus event on the checkbox input
         * Sets the focused state and triggers a re-render
         */
        handleFocus() {
            this._isFocused = true;
            this.requestUpdate();
            // Dispatch a custom focus event
            const focusEvent = new CustomEvent(SdsCheckbox.FOCUS_EVENT, {
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(focusEvent);
        }
        /**
         * Handles the blur event on the checkbox input
         * Clears the focused and clicked states and triggers a re-render
         */
        handleBlur() {
            this._isFocused = false;
            this._isClicked = false;
            this.requestUpdate();
            // Dispatch a custom blur event
            const blurEvent = new CustomEvent(SdsCheckbox.BLUR_EVENT, {
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(blurEvent);
        }
        /**
         * Handles the click event on the checkbox label
         * Prevents focus styling when the checkbox is clicked with a mouse
         */
        handleClick() {
            if (!this._isClicked) {
                this._isFocused = false;
                this.requestUpdate();
            }
            // Dispatch a custom click event
            const clickEvent = new CustomEvent(SdsCheckbox.CLICK_EVENT, {
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(clickEvent);
        }
        /**
         * Handles keyboard events on the checkbox
         * Manages focus styling based on keyboard interaction
         *
         * @param e - The keyboard event
         */
        handleKeyDown(e) {
            // Ignore modifier keys (Shift, Ctrl, Alt, Meta)
            if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt' || e.key === 'Meta') {
                return;
            }
            // Handle Space key for toggling the checkbox
            if (e.key === ' ' || e.key === 'Space') {
                this._isFocused = true;
                this._isClicked = true;
                this.requestUpdate();
            }
            else {
                this._isFocused = false;
                this.requestUpdate();
            }
        }
        /**
         * Handles the change event on the checkbox input
         * Updates the component state and dispatches change events
         */
        handleChange() {
            this.checked = this._checkbox.checked;
            this.indeterminate = this._checkbox.indeterminate;
            const change = new CustomEvent(SdsCheckbox.CHANGE_EVENT, {
                detail: {
                    checked: this.checked,
                    indeterminate: this.indeterminate,
                },
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(change);
            const nativeChange = new CustomEvent(SdsCheckbox.NATIVE_CHANGE_EVENT, {
                detail: {
                    checked: this.checked,
                    indeterminate: this.indeterminate,
                },
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(nativeChange);
        }
        /**
         * Updates the indeterminate state of the native input when the property changes
         * This is necessary because the indeterminate property can only be set via JavaScript
         *
         * @param changedProperties - Map of properties that have changed
         */
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has('indeterminate') && this._checkbox) {
                this._checkbox.indeterminate = this.indeterminate;
            }
            // Ensure the native input's checked state is synchronized with the component's checked property
            if (changedProperties.has('checked') && this._checkbox) {
                this._checkbox.checked = this.checked;
            }
        }
        /**
         * Renders the checkbox component
         *
         * @returns The rendered HTML template
         */
        render() {
            if (this.readonly) {
                return html `
                <div
                    class="sds-checkbox sds-checkbox--readonly sds-checkbox--checked"
                    role="checkbox"
                    aria-checked="true"
                    aria-disabled="true"
                    tabindex="-1"
                >
                    ${this.label || this.description
                    ? html ` <div class="sds-checkbox__content">
                              ${this.label
                        ? html ` <div class="sds-checkbox__label">${this.label}</div>`
                        : html ``}
                              ${this.description
                        ? html ` <div class="sds-checkbox__description">
                                        ${this.description}
                                    </div>`
                        : html ``}
                          </div>`
                    : html ``}
                </div>
            `;
            }
            return html `
            <label class="${this.getClasses()}" for="${this._unique}">
                <input
                    class="sds-checkbox__input"
                    type="checkbox"
                    id="${this._unique}"
                    ?checked="${this.checked}"
                    ?disabled="${this.disabled}"
                    .indeterminate="${this.indeterminate}"
                    aria-invalid="${this.invalid}"
                    aria-describedby="${this.description ? `${this._unique}-description` : ''}"
                    value="${this.value}"
                    name="${this.name}"
                    @change="${() => this.handleChange()}"
                    @focus="${() => this.handleFocus()}"
                    @blur="${() => this.handleBlur()}"
                    @click="${() => this.handleClick()}"
                    @keydown="${(e) => this.handleKeyDown(e)}"
                />
                ${this.label || this.description
                ? html ` <div class="sds-checkbox__content">
                          ${this.label
                    ? html ` <div class="sds-checkbox__label">${this.label}</div>`
                    : html ``}
                          ${this.description
                    ? html ` <div class="sds-checkbox__description">
                                    ${this.description}
                                </div>`
                    : html ``}
                      </div>`
                : html ``}
            </label>
            ${this.renderError()}
        `;
        }
        /**
         * Standard event listener registration for native events.
         *
         * @param type - The event type to listen for (e.g., 'focus', 'blur', 'click')
         * @param listener - The event listener function with proper 'this' context
         * @param options - Optional event listener options (capture, once, passive)
         */
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        /**
         * Renders the error message if the checkbox is invalid
         *
         * @returns The rendered error message template or undefined
         */
        renderError() {
            if (this.errorMessage && this.invalid) {
                return html `
                <sds-error id="${this._unique}-error" message="${this.errorMessage}"></sds-error>
            `;
            }
        }
        /**
         * Gets the CSS classes to apply to the checkbox based on its state
         *
         * @returns An object mapping class names to boolean values
         */
        getClasses() {
            return classMap({
                'sds-checkbox': true,
                'sds-checkbox--checked': this.checked,
                'sds-checkbox--indeterminate': this.indeterminate,
                'sds-checkbox--disabled': this.disabled,
                'sds-checkbox--invalid': this.invalid,
                'sds-checkbox--focused': this._isFocused,
            });
        }
    };
    _SdsCheckbox_label_accessor_storage = new WeakMap();
    _SdsCheckbox_description_accessor_storage = new WeakMap();
    _SdsCheckbox_checked_accessor_storage = new WeakMap();
    _SdsCheckbox_readonly_accessor_storage = new WeakMap();
    _SdsCheckbox_indeterminate_accessor_storage = new WeakMap();
    _SdsCheckbox_disabled_accessor_storage = new WeakMap();
    _SdsCheckbox_invalid_accessor_storage = new WeakMap();
    _SdsCheckbox_errorMessage_accessor_storage = new WeakMap();
    _SdsCheckbox_value_accessor_storage = new WeakMap();
    _SdsCheckbox_name_accessor_storage = new WeakMap();
    _SdsCheckbox__checkbox_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsCheckbox");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _label_decorators = [property({ type: String })];
        _description_decorators = [property({ type: String })];
        _checked_decorators = [property({ type: Boolean })];
        _readonly_decorators = [property({ type: Boolean })];
        _indeterminate_decorators = [property({ type: Boolean })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _value_decorators = [property({ type: String })];
        _name_decorators = [property({ type: String })];
        __checkbox_decorators = [query('input[type=checkbox]')];
        __esDecorate(_classThis, null, _label_decorators, { kind: "accessor", name: "label", static: false, private: false, access: { has: obj => "label" in obj, get: obj => obj.label, set: (obj, value) => { obj.label = value; } }, metadata: _metadata }, _label_initializers, _label_extraInitializers);
        __esDecorate(_classThis, null, _description_decorators, { kind: "accessor", name: "description", static: false, private: false, access: { has: obj => "description" in obj, get: obj => obj.description, set: (obj, value) => { obj.description = value; } }, metadata: _metadata }, _description_initializers, _description_extraInitializers);
        __esDecorate(_classThis, null, _checked_decorators, { kind: "accessor", name: "checked", static: false, private: false, access: { has: obj => "checked" in obj, get: obj => obj.checked, set: (obj, value) => { obj.checked = value; } }, metadata: _metadata }, _checked_initializers, _checked_extraInitializers);
        __esDecorate(_classThis, null, _readonly_decorators, { kind: "accessor", name: "readonly", static: false, private: false, access: { has: obj => "readonly" in obj, get: obj => obj.readonly, set: (obj, value) => { obj.readonly = value; } }, metadata: _metadata }, _readonly_initializers, _readonly_extraInitializers);
        __esDecorate(_classThis, null, _indeterminate_decorators, { kind: "accessor", name: "indeterminate", static: false, private: false, access: { has: obj => "indeterminate" in obj, get: obj => obj.indeterminate, set: (obj, value) => { obj.indeterminate = value; } }, metadata: _metadata }, _indeterminate_initializers, _indeterminate_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
        __esDecorate(_classThis, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(_classThis, null, __checkbox_decorators, { kind: "accessor", name: "_checkbox", static: false, private: false, access: { has: obj => "_checkbox" in obj, get: obj => obj._checkbox, set: (obj, value) => { obj._checkbox = value; } }, metadata: _metadata }, __checkbox_initializers, __checkbox_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsCheckbox = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    /** Event name for the custom change event */
    _classThis.CHANGE_EVENT = 'sds.checkbox.changed';
    /** Event name for the native change event */
    _classThis.NATIVE_CHANGE_EVENT = 'change';
    /** Event name for the native focus event */
    _classThis.FOCUS_EVENT = 'focus';
    /** Event name for the native blur event */
    _classThis.BLUR_EVENT = 'blur';
    /** Event name for the native click event */
    _classThis.CLICK_EVENT = 'click';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsCheckbox = _classThis;
})();
export { SdsCheckbox };
